import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight } from '@iwoca/icons';
import { Button, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const ShowFlexibleOffersCard = ({
    showOtherOffers
}: {
    showOtherOffers: () => void;
}) => {
    return (
        <div className="space-y-l rounded-l bg-secondary-90 p-l">
            <div>
                <h5 className="my-0 text-l font-bold">
                    <FormattedMessage
                        id="_.rcf_approved_view.switch_to_flexi_offers_title"
                        defaultMessage="Do you prefer a one-time payout and a regular repayment plan?"
                    />
                </h5>
                <Text>
                    <FormattedMessage
                        id="_.rcf_approved_view.flexi_credit_disclaimer"
                        defaultMessage="Our Flexi credit might suit you better. This is not financial advice."
                    />
                </Text>
            </div>

            <Button
                className="w-full"
                variant="secondary-alt"
                onClick={() => {
                    tracking.ampli.flexibleOfferCardClicked();
                    showOtherOffers();
                }}
            >
                <FormattedMessage
                    id="_.rcf_approved_view.back_to_flexi_credit"
                    defaultMessage="Back to Flexi credit"
                />{' '}
                <IconAngleRight />
            </Button>
        </div>
    );
};
